/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 */
 
 
document.addEventListener('variant:changed', function(event) {
  let variant = event.detail.variant; // Gives you access to the whole variant details
  let form = event.target;  
  let outStockButton = document.querySelector(".klaviyo-bis-trigger");
    
  if (!outStockButton) {
    return;
  }
  outStockButton.style.display = !variant || !variant["available"] ? "block" : "none";
});


/****************************************************************/
/* APLICAR DESCUENTOS DESDE LA URL 							*/
/*
let params = new URLSearchParams(window.location.search);
let promocode = params.get('promocode') 
if (promocode) {
	var urll = '/discount/' + promocode;
  	fetch(urll)  	
  	.then(data => console.log(data));  
}
*/

/****************************************************************/
/* COMPROBAR COOKIES TERMS HUB   							    */
/****************************************************************/
var conset_data = false;

function buscar_cookie() {
  var nombreTermsHub = "termshub-consent=";
  var ca = document.cookie.split(';');
  var cookie_obj = "";  
  
  for(var i=0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
      if (c.indexOf(nombreTermsHub) == 0) cookie_obj = JSON.parse(c.substring(nombreTermsHub.length,c.length));      
  }

  return cookie_obj;
}
  
function inicializar() {
  var cookie_obj = buscar_cookie();

  // Define dataLayer and the gtag function.
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}

  gtag('js', new Date());
  gtag('config', 'G-PYJEQVRY71');    
  
  if (cookie_obj == "") {    
    console.log("NO COOKIES");      
    // Set default consent to 'denied' as a placeholder    
    gtag('consent', 'default', {
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'analytics_storage': 'denied'
    });  

    gtag('consent', 'update', {
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied',
      'analytics_storage': 'denied'
    });    
    
  } else if (cookie_obj.categories) {      
    var necessary_val = cookie_obj.categories.necessary.wanted ? 'granted' : 'denied';    
    var analytics_val = cookie_obj.categories.statistics.wanted ? 'granted' : 'denied';
    var functional_val = cookie_obj.categories.functional.wanted ? 'granted' : 'denied';
    var ads_val = cookie_obj.categories.marketing.wanted ? 'granted' : 'denied';
    gtag('consent', 'update', {
      'ad_storage': ads_val,
      'ad_user_data': ads_val,
      'ad_personalization': ads_val,
      'analytics_storage': analytics_val
    });     
  }  
}

function consent_check() {
  var cookie_obj = buscar_cookie();
  
  if (cookie_obj.categories) {    
    var necessary_val = cookie_obj.categories.necessary.wanted ? 'granted' : 'denied';    
    var analytics_val = cookie_obj.categories.statistics.wanted ? 'granted' : 'denied';
    var functional_val = cookie_obj.categories.functional.wanted ? 'granted' : 'denied';
    var ads_val = cookie_obj.categories.marketing.wanted ? 'granted' : 'denied';
    gtag('consent', 'update', {
      'ad_storage': ads_val,
      'ad_user_data': ads_val,
      'ad_personalization': ads_val,
      'analytics_storage': analytics_val
    });     
    conset_data = true;
  }  
}

// Función para verificar si se ha modificado una cookie
function verificarCambiosEnCookies(callback) {
    // Guardar una copia del estado actual de las cookies
    var cookiesAnteriores = document.cookie;

    // Establecer un intervalo de tiempo para verificar continuamente los cambios en las cookies
    setInterval(function() {
        // Obtener el estado actual de las cookies
        var cookiesActuales = document.cookie;

        // Verificar si ha habido cambios en las cookies
        if (cookiesActuales !== cookiesAnteriores) {            
            // Ejecutar la función de callback cuando se detecte un cambio
            callback();
            // Actualizar el estado de las cookies para la próxima comparación
            cookiesAnteriores = cookiesActuales;
        }
    }, 1000); // Intervalo de verificación (en milisegundos)
}

inicializar();
// Llamar a la función para verificar cambios en las cookies
verificarCambiosEnCookies(consent_check);
/* SINCRONIZAR SWATCH DE COLOR CON EL PLP MEDIA SLIDER */

document.addEventListener("change", async function (event) {
  var input = event.target.closest(
    ".product-item-meta__swatch-list .color-swatch__radio"
  );

  if (!input) return;

  var productItem = input.closest("product-item");

  if (!productItem) return;

  var slider = productItem.querySelector(".product-item__plp-slider");

  if (!slider || !slider.flickityInstance) return;

  var featuredMediaId = input.getAttribute(
    "data-variant-featured-media"
  );

  if (!featuredMediaId) return;

  var targetCell = slider.querySelector(
    '[data-media-id="' + featuredMediaId + '"]'
  );

  if (!targetCell) return;

  var flickity = await slider.flickityInstance;

  flickity.selectCell(targetCell);
});